import request from "@/request/request";
// 查询官网新闻资讯列表 /api/distributionOfficialNews/list
export function newsList(data) {
  return request({
    url: "/api/distributionOfficialNews/list",
    method: "get",
    params: data,
  });
}

// 新增官网留言 /api/distributionOfficialLeavemsg
export function distributionOfficialLeavemsg(data) {
  return request({
    url: "/api/distributionOfficialLeavemsg",
    method: "post",
    data,
  });
}
// /api/distributionOfficialNews/
export function getNews(ids) {
  return request({
    url: "/api/distributionOfficialNews/" + ids,
    method: "get",
  });
}
